import * as firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import {v4 as uuidv4} from "uuid";
import Loader from "@/components/loader/Loader.vue";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import TimeRangeDropdown from "@/components/pickers/TimeRangeDropdown.vue";
import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";
import ConfirmMessageDlg from "@/components/popup/confirm-message-dialog/ConfirmMessageDlg.vue";
import ManipulateCalendarEventDialog
    from "@/views/calender/manipulate-calendar-event-dialog/ManipulateCalendarEventDialog.vue";
import BusinessHours from 'vue-business-hours';
import DeleteServiceDialog from "@/views/premium-services/delete-premium-service-dialog/DeletePremiumServiceDialog.vue";
import GalleryPhotosUploadDlg from "@/views/staff/gallery/GalleryPhotosUploadDlg/GalleryPhotosUploadDlg.vue";

import moment from "moment";
import {EventsTypes} from "@/enums/EventsTypes";
import {ServiceTypeIntegrationEnum} from "@/enums/ServiceTypeIntegrationEnum";
import {getRegionName} from "@/utils/functionsRegion";
import {ValidationRules} from "@/utils/validation-rules";
import {ServiceStatus} from "@/enums/ServiceStatus";
import {convertTimeDurationTo24hFormat, convertTimeTo24HourInArray} from "@/utils/dateTimeFormat";
import {toTranslationKey} from "@/utils/stringFormat";
import {slotDurationsInMins} from "@/consts/SlotDurationsInMins";
import {
    isPremiumServiceAvailableHoursValid,
    sortPremiumServiceAvailableHours
} from "@/consts/PremiumServiceAvailableHours";
import {dateFormats} from "@/consts/DateTimeFormats";
import {vueBusinessHoursTranslations} from "@/locales/npms/vue-business-hours/vue-business-hours";
import {batchUpdate} from "@/utils/batchUpdate";
import {ConciergeServiceMixin} from "@/mixins/ConciergeService";
import {ServiceTypeEnum} from "@/enums/ServiceTypeEnum";
import {NewAdditionalService} from "@/models/additional-service/NewAdditionalService";
import i18n from "@/plugins/vueI18n";
import {optimizePhotos} from "@/utils/upload-image";
import {fileSizeToMB, validFileSize10MB} from "@/utils/fileSizeToMB";
import {EventLocationsMixin} from "@/mixins/EventLocations";
import {
    PremiumServiceEventTypeEnum,
    PremiumServiceEventTypes,
    PremiumServiceProductTypeEnum,
    PremiumServiceRequestTypeEnum
} from "@/enums/PremiumServiceEventTypes";
import {serializer} from "@/api/shared/serializer";
import { EventLocations } from "@/enums/EventLocations";
import { RecurringEventsType, RecurringRepeatType } from "@/enums/RecurringEventsType";
import { ResidentsRequestTypeEnum } from "@/enums/ResidentsRequestTypeEnum";
import { waitResizedImage } from "@/utils/wait-resized-image";
import { DEFAULT_NO_IMAGE } from "@/consts/default-no-image";
import {GalleryImage} from "@/models/GalleryImage";
import {PremiumServiceParticipantsLimit} from "@/enums/PremiumServiceParticipantsLimit";

export default {
    name: "ConciergeService",
    mixins: [
        ConciergeServiceMixin,
        EventLocationsMixin
    ],
    components: {
        Loader,
        ValidationObserver,
        ValidationProvider,
        TimeRangeDropdown,
        BusinessHours,
        ConfirmDlg,
        ManipulateCalendarEventDialog,
        ConfirmMessageDlg,
        DeleteServiceDialog,
        GalleryPhotosUploadDlg
    },
    data() {
        return {
            defaultNoImageUrl: DEFAULT_NO_IMAGE,
            eventsTypes: EventsTypes,
            integrationTypes: ServiceTypeIntegrationEnum,
            profilePicUploadStatus: 100,
            nowDate: moment(new Date()),
            isPremiumServiceAvailableHoursValid: true,
            loading: true,
            loadingChange: false,
            loadedVendorsData: false,
            loadedCalenderEvents: false,
            slotDurationsInMins: slotDurationsInMins,
            searchCategoryInput: "",
            oneOffCost: 0,
            menu: false,
            hintDateFormat: '',
            startDateSelected: '',
            minDate: moment(new Date()).format('YYYY-MM-DD'),
            time: {
                start: '',
                end: '',
            },
            indexAdditionalPhoto: null,
            isLoadingMeetingTimes: false,
            isOffice365Event: false,
            isLoadedMsCalendarEvents: false,
            eventDates: [],
            busyEventDates: [],
            msCalendarEvents: [],
            office365DurationMins: 15,
            serviceRequestDurationHours: 1,
            availableTimes: [],
            currentRoomLocation: null,
            isTimeRangeValid: true,
            isMsEventHourDurationInitialized: false,
            prevLocation: null,
            newLocation: null,
            recurringMeetingTimeSlot: '',
            addtService: new NewAdditionalService(),
            isServiceLoading: true,
            isLocationsLoading: true,
            isVendorDataLoading: false,
        };
    },
  
    async beforeCreate() {

        this.addtService = await this.$store.dispatch("getAdditionalServiceWithoutRelatedData", this.$route.params.id)
        this.setCostServices()
        this.isServiceLoading = false

        const addtServiceEvents = await this.$store.dispatch("getAdditionalServiceEvents", this.$route.params.id)
        this.addtService.events = addtServiceEvents

        await this.$store.dispatch("getEventLocations")
        this.isLocationsLoading = false

        await this.$store.dispatch("getLifestyleProgramCategories")
        this.isCategoriesLoading = false

        await this.$store.dispatch("getAdditionalServiceRequestsByServiceId", this.addtService.id)
        await this.$store.dispatch("getAdditionalServices")
        await this.$store.dispatch("getFacility")

        if(this.addtService.sendVendorEmailUponRequestAutomatically === true){
            await this.loadVendorsData()
        }

        if(this.isEnableRoomBooking){
            await this.updateLocationValue(this.additionalService.location, true);
        }
        else {
            this.setOffice365EventState(false);
        }

        this.loading = false;

        if (this.additionalService?.availableHours) {
            this.additionalService.availableHours = sortPremiumServiceAvailableHours(this.additionalService.availableHours)
        }

        if (this.additionalService?.durationHours === 0 || this.additionalService?.durationHours === 0.0) {
            this.additionalService.durationHours = null;
        }

        if (this.additionalService?.start) {
            const dateFormat = dateFormats.find(x => x.format == this.selectedFacility.dateFormat);
            this.time.start = moment(this.additionalService?.start.seconds * 1000).format(this.timeFormat);
            this.time.end = moment(this.additionalService?.end.seconds * 1000).format(this.timeFormat);
            this.hintDateFormat = dateFormat ? dateFormat.name : dateFormats[0].name;
            this.startDateSelected = moment(this.additionalService?.start.seconds * 1000).format('YYYY-MM-DD');
        }

        if(this.additionalService?.wingsIds && this.additionalService?.wingsIds.length) {
            this.selectedWingsIds = this.additionalService.wingsIds;
        }
    },
    beforeDestroy() {
        this.$store.dispatch("clearCurrentAdditionalService");
        this.$store.dispatch("clearCurrentCalenderRecurringEvents");
    },
    computed: {
        checkAvailableTime(value) {
            this.isTimeRangeValid = !!value;
        },
        participantsLimitItems() {
            const defaultList = [this.PremiumServiceParticipantsLimitTypes.Unlimited, this.PremiumServiceParticipantsLimitTypes.SetLimit];
            const timeSlotLimits = [this.PremiumServiceParticipantsLimitTypes.LimitPerTimeSlot];
            const limits = this.additionalService.byAppointment ? [...defaultList, ...timeSlotLimits] : defaultList;

            return limits.map(x => ({
                text: toTranslationKey(x),
                value: x
            }));
        },
        timeFormat() {
            return this.$store.state.facilityModule.selectedFacility.timeFormat;
        },
        oneOffMembers() {
            const result = this.additionalService?.membersList?.filter(x => x.isOneOff);
            return result ? result : [];
        },
        notOneOffMembers() {
            const result = this.additionalService?.membersList?.filter(x => !x.isOneOff);
            return result ? result : [];
        },
        serviceRequests() {
            return this.$store.state.additionalServicesModule.serviceRequestByServiceId;
        },
        awaitingApprovalMembers() {
            return this.serviceRequests
              .filter(x => x.status === ServiceStatus.AwaitingApproval)
              .map(x => {
                  const residentData = this.residents?.find(resident => resident.id === x.residentId);

                  return {
                      residentId: x.residentId,
                      imageUrl: residentData.imageUrl ?? residentData.ImageUrl,
                      name: residentData.name,
                      serviceRequestId: x.id,
                      facilityId: x.facilityId
                  }
              })
        },
        bookedMembers() {
            return this.additionalService?.membersList || [];
        },
        additionalService(): NewAdditionalService {
            return this.addtService || {
                name: '',
                type: '',
                imageUrl: DEFAULT_NO_IMAGE,
            };
        },
        serviceType() {
            const type = this.additionalService?.type;

            if ([this.PremiumServiceEventTypes.Request, this.PremiumServiceEventTypes.AppAccess, this.PremiumServiceEventTypes.ByAppointment].includes(type)) {
                return this.PremiumServiceEventTypes.Request;
            } else if ([this.PremiumServiceEventTypes.EventBased, this.PremiumServiceEventTypes.ConciergeEvent, this.PremiumServiceEventTypes.Event].includes(type)) {
                return this.PremiumServiceEventTypes.Event;
            } else if ([this.PremiumServiceEventTypes.Gift, this.PremiumServiceEventTypes.Product].includes(type)) {
                return this.PremiumServiceEventTypes.Product;
            } else {
                return type;
            }
        },
        serviceTypes() {
            return ServiceTypeEnum;
        },
        isRequest() {
            return this.serviceType === this.PremiumServiceEventTypes.Request;
        },
        isEvent() {
            return this.serviceType === this.PremiumServiceEventTypes.Event;
        },
        isProduct() {
            return this.serviceType === this.PremiumServiceEventTypes.Product;
        },
        additionalServices() {
            const additionalServices = this.$store.state.additionalServicesModule.additionalServices;
            const typeFilter = (types) => (service) => types.includes(service.type);

            const filterAndSort = (types) => {
                return additionalServices
                    .filter(typeFilter(types))
                    .sort((a, b) => a.orderIndex - b.orderIndex);
            };

            if ([this.PremiumServiceEventTypes.EventBased, this.PremiumServiceEventTypes.ConciergeEvent, this.PremiumServiceEventTypes.Event].includes(this.additionalService.type)) {
                return filterAndSort([this.PremiumServiceEventTypes.EventBased, this.PremiumServiceEventTypes.ConciergeEvent, this.PremiumServiceEventTypes.Event]);
            }

            if ([this.PremiumServiceEventTypes.ByAppointment, this.PremiumServiceEventTypes.AppAccess, this.PremiumServiceEventTypes.Request].includes(this.additionalService.type)) {
                return filterAndSort([this.PremiumServiceEventTypes.ByAppointment, this.PremiumServiceEventTypes.AppAccess, this.PremiumServiceEventTypes.Request]);
            }

            if ([this.PremiumServiceEventTypes.Gift, this.PremiumServiceEventTypes.Product].includes(this.additionalService.type)) {
                return filterAndSort([this.PremiumServiceEventTypes.Gift, this.PremiumServiceEventTypes.Product]);
            }

            return additionalServices;
        },
        isParticipantLimitTypesSetLimit() {
            return this.additionalService.participantLimit === this.PremiumServiceParticipantsLimitTypes.SetLimit;
        },
        isParticipantLimitTypesLimitPerTimeSlot() {
            return this.additionalService.participantLimit === this.PremiumServiceParticipantsLimitTypes.LimitPerTimeSlot;
        },
        rules(): object {
            return {
                name: [ValidationRules.required, ValidationRules.max(50)],
                comment: [ValidationRules.max(100)],
                selection: [ValidationRules.required],
                slotDurationInMins: [ValidationRules.required,ValidationRules.positiveNumber, value => /^[0-9]+$/.test(value) || 'Only integer numbers are allowed'],
                durationHours: [ValidationRules.positiveNumber, value => value ? /^\d+(\.\d+)?$/.test(value) || 'Only decimal numbers are allowed' : null],
                participantLimitNumber: [ValidationRules.required, ValidationRules.positiveNumber, value => /^[1-9][0-9]*$/.test(value) || 'Only integers greater than 0 are allowed'],
                maxSlots: [ValidationRules.required, ValidationRules.positiveNumber, value => /^[1-9][0-9]*$/.test(value) || 'Only integers greater than 0 are allowed'],
                oneOffCost: [ValidationRules.required, this.validPrice],
            };
        },
        validPrice() {
            if (this.additionalService?.oneOffCost === "POA" || this.additionalService?.oneOffCost === "Free") {
                return true;
            }

            return (!isNaN(parseFloat(this.oneOffCost)) && this.oneOffCost >= 0) || i18n.t('ValidationRules.PositiveNumber');
        },
        isServiceTypeDailyCharge() {
            return this.additionalService.serviceType === this.serviceTypes.DailyCharge;
        },
        isConciergeEvent() {
            return this.additionalService.type === PremiumServiceEventTypeEnum.Event;
        },
        localization() {
            return vueBusinessHoursTranslations[this.$i18n.locale]
        },
        showAddCategoryBtn() {
            const value = this.searchCategoryInput ? this.searchCategoryInput.trim().toLocaleLowerCase() : ''

            if (value.length <= 0) return false

            const existed = this.serviceCategories.some(x => x.name.trim().toLocaleLowerCase() === value)

            return !existed
        },
        startDateFormatted() {
            if (!this.hintDateFormat || !this.startDateSelected) return ''

            return moment(this.startDateSelected).format(this.hintDateFormat)
        },
        residents() {
            return this.$store.state.residentModule.residentsShortData;
        },
        isWaitingList() {
            if (this.additionalService.participantLimit) {
                return this.additionalService.participantLimit === this.PremiumServiceParticipantsLimitTypes.SetLimit;
            }
        },
        waitingList() {
            if (!this.additionalService?.waitingResidentsIds || !this.residents) {
                return [];
            }

            const residentsMap = this.residents.reduce((map, resident) => {
                map[resident.id] = {
                    id: resident.id,
                    name: resident.name,
                    imageUrl: resident.imageUrl ?? resident.ImageUrl
                };
                return map;
            }, {});

            return this.additionalService.waitingResidentsIds.map(id => residentsMap[id]);
        },
        facility() {
            return this.$store.state.facilityModule.selectedFacility;
        },
        serviceCategories() {
            return this.$store.state.socialClubModule.lifestyleProgramCategories
        },
        eventLocations() {
            return this.$store.state.eventLocationModule.eventLocations.filter(x => x.type !== EventLocations.Wing).map(x => ({
                name: x.name,
                value: x.name,
                type: x.type
            }))
        },
        isEnableRoomBooking() {
            return this.$store.state.facilityModule.selectedFacility.isEnableRoomBooking;
        },
        locations() {
            return this.$store.state.eventLocationModule.eventLocations;
        },
        calendarEvents() {
            return this.$store.state.calenderModule.calenderEvents;
        },
        isPublishedEvent() {
            if(this.isEvent && this.additionalService?.isPublished) {
                return true
            }

            return false;
        }
    },
    methods: {
        
        async loadMsCalendarEvents(){
            if(this.isOffice365Event) {
                const params = {
                    facilityId: this.currentFacility,
                    range: {
                        startDateTime: moment().startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
                        endDateTime: moment().endOf('day').add(1, 'month').format('YYYY-MM-DDTHH:mm:ss')
                    }
                }
                await this.$store.dispatch('msCalendarView', params).then(response => {
                    this.isLoadedMsCalendarEvents = true
                    if (response.data?.data?.length > 0) {
                        this.msCalendarEvents = response.data.data
                        this.eventDates = this.eventDates.concat(response.data.data.map(x=>x.date));
                    }
                })
            }
        },

        async updateLocationValue(value: string, isInitFunc?: boolean): Promise<void> {

            if (this.locations.some((location: { type: EventLocations; name: string}) => [EventLocations.Location, EventLocations.Room].includes(location.type) && location.name === value) && this.isEnableRoomBooking) {
                await this.loadCalenderEvents()
                this.currentRoomLocation = this.locations.find((location: { name: string }) => location.name === value);
                this.newLocation = this.locations.find(x=>x.name === this.location)
                this.additionalService.office365Email = this.newLocation?.office365Email || null
                const locationEvents = this.calendarEvents.filter(ev => ev.location === value);
                this.setOffice365EventState(true);
                await this.findMeetingTimes(true);
                if (isInitFunc) {

                    const startTime = moment(this.additionalService.start.seconds * 1000).format(this.facility.timeFormat);
                    const endTime = moment(this.additionalService.end.seconds * 1000).format(this.facility.timeFormat);
                    this.office365DurationMins = moment(endTime, this.facility.timeFormat).diff(moment(startTime, this.facility.timeFormat), 'minutes');

                    const times = this.availableTimes[0]?.value === null ? [] : this.availableTimes;
                    this.availableTimes = [...times, {text: startTime, value: startTime}];
                    this.time.start = moment(this.additionalService.start.seconds * 1000).format(this.facility.timeFormat);
                }
                if (locationEvents.length > 0) {
                    locationEvents.forEach(event => {
                        const date = new Date(event.startISOString).toISOString().split('T')[0];
                        this.eventDates.push(date);
                        this.busyEventDates.push(date);
                    });
                }
                await this.loadMsCalendarEvents()
            } else {
                this.setOffice365EventState(false);
            }
        },

        async findMeetingTimes(isInitFunc?: boolean, setCurrentHourDuration?: boolean): Promise<void> {

            if(!this.isOffice365Event) return
    
            if(!this.startDateSelected?.length ) {
                this.availableTimes = [{text: this.$t("NewCalendarItem.NotAvailableHours"), value: null}]
                return
            }
            else{
                await this.findMeetingTimesForSingleEvent(isInitFunc)
            }

            this.addCurrentOffice365HourDurationToList(setCurrentHourDuration)
        },
        async findMeetingTimesForSingleEvent(isInitFunc?: boolean): Promise<void> {

            if (!this.isOffice365Event) return


            this.isLoadingMeetingTimes = true

            const startDateTime = moment(this.startDateSelected).startOf('day').format('YYYY-MM-DDTHH:mm:ss');
            
            const endDateTime = moment(this.startDateSelected).endOf('day').format('YYYY-MM-DDTHH:mm:ss');

            if (!isInitFunc) {
                this.time.start = moment(this.additionalService.start.seconds * 1000).locale(i18n.locale).format(this.facility.timeFormat);
                this.office365DurationMins = this.office365DurationMins > 0 ? this.office365DurationMins : +moment(this.additionalService.end.seconds * 1000).locale(i18n.locale).format(this.facility.timeFormat).split(':')[0] - +this.time.start.split(':')[0];
            }

            if (this.isOffice365Event) {

                const params = {
                    roomName: this.currentRoomLocation?.isDifferentName ? this.currentRoomLocation.differentName : this.currentRoomLocation.name,
                    startDateTime,
                    endDateTime,
                    meetingDurationInMins: this.office365DurationMins,
                    facilityId: this.currentFacility
                }

                return await this.$store.dispatch('findMsMeetingTimes', params)
                    .then(response => {
                        if (response.data?.data?.length > 0) {
                            this.availableTimes = response.data.data.map(el => {
                                const timeSlot = `${moment(el.meetingTimeSlot?.start.dateTime).format(this.facility.timeFormat)}`;
                                return {text: timeSlot, value: timeSlot}
                            });
                        } else {
                            this.availableTimes = [{text: this.$t("NewCalendarItem.NotAvailableHours"), value: null}];
                        }
                    }).catch((error) => {
                    console.error(error);
                }).finally(() => {
                    this.isLoadingMeetingTimes = false
                })
            }
        },
        setOffice365EventState(state) {
            this.isOffice365Event = state;

            this.updateMaxDate()
        },
        updateMaxDate(){
            if(this.isOffice365Event === true){
                if((this.additionalService.recurringType === RecurringEventsType.Monthly 
                    || (this.additionalService.recurringType === RecurringEventsType.Custom && this.additionalService.recurringRepeatType === RecurringRepeatType.Month))){
                    this.maxDate = moment(this.startRecurringDate).add(1, "year").format('YYYY-MM-DD'); 
                }
                else{
                    this.maxDate = moment(this.startRecurringDate).add(50, "days").format('YYYY-MM-DD');
                }
            }
            else{
                this.maxDate = moment(new Date()).add(1, "year").format('YYYY-MM-DD');
            }
        },
        getEventColor(date){
            if (this.busyEventDates.includes(date) || this.msCalendarEvents.some(d => d.date === date && d.items.length > 0)) {
                return'orange';
            } 
            else if (this.msCalendarEvents.some(d => d.date === date && d.items.length <= 0)) {
                return'green';
            }
    
            return 'white';
        },
        addCurrentOffice365HourDurationToList(force){
            
            if(!this.isOffice365Event || this.isMsEventHourDurationInitialized === true && !force) return

            let duration = ''

            if(this.additionalService.isRecurring){
                duration = `${moment(this.additionalService.start.seconds * 1000).format(this.facility.timeFormat || 'HH:mm')}-${moment(this.additionalService.end.seconds * 1000).format(this.facility.timeFormat || 'HH:mm')}`
                if(!this.availableTimes.find(x=>x.value === duration)){
                    this.availableTimes.push({text: duration, value: duration})
                    this.recurringMeetingTimeSlot = duration
                }
                else if(this.recurringMeetingTimeSlot !== duration){
                    this.recurringMeetingTimeSlot = duration
                }
            }
            else{
                duration = moment(this.additionalService.start.seconds * 1000).format(this.facility.timeFormat || 'HH:mm')
                if(!this.availableTimes.find(x=>x.value === duration)){
                    this.availableTimes.push({text: duration, value: duration})
                    this.time.start = duration
                }
                else if(this.recurringMeetingTimeSlot !== duration){
                    this.time.start = duration
                }
            }

            this.isMsEventHourDurationInitialized = true
        },
        decrementOffice365DurationMins() {
      
            if (this.readonly) return

            if (!this.office365DurationMins || this.office365DurationMins <= 15) {
                this.office365DurationMins = 15;
            }
            else {
                this.office365DurationMins = +this.office365DurationMins-15;
            }
    
            this.$forceUpdate();
            this.findMeetingTimes();
        },

        incrementOffice365DurationMins() {

            if (this.readonly) return

            if (!this.office365DurationMins) {
                this.office365DurationMins = 15;
            }
            else {
                this.office365DurationMins = +this.office365DurationMins+15;
            }
            this.$forceUpdate();
            this.findMeetingTimes();
        },
        async addCategory() {
            if (!this.serviceCategories) return

            const value = this.searchCategoryInput?.trim() || null

            if (!value || value?.length <= 0) return

            if (this.serviceCategories.some(x => x.name === value)) return

            const newCategory = {
                name: value,
                color: '#FFFFFF'
            }

            await this.$store.dispatch("addLifestyleProgramCategory", newCategory)
                .then(async (categoryId) => {
                      await this.$store.dispatch("getLifestyleProgramCategories").then(() => {
                          this.$forceUpdate();
                          this.additionalService.category = value.name;
                          this.additionalService.categoryId = categoryId;
                          this.$toast.open({
                              message: this.$t('CreatePremiumService.CategorySuccessfullyAddedMessage') as string,
                              type: "success"
                          });
                      })
                }).catch((error) => {
                    console.error(error)
                    this.$toast.open({message: this.$t('GeneralTranslations.UndefinedError') as string, type: "error"});
                });
        },
        incrementParticipantLimitNumber() {
            if (!this.additionalService.participantLimitNumber) {
                this.additionalService.participantLimitNumber = 1;
            } else {
                this.additionalService.participantLimitNumber++;
            }
            this.$forceUpdate();
        },
        decrementParticipantLimitNumber(): void {
            if (this.additionalService.participantLimitNumber > 1) {
                this.additionalService.participantLimitNumber--;
                this.$forceUpdate();
            }

            if (!this.additionalService.participantLimitNumber) {
                this.additionalService.participantLimitNumber = 1;
                this.$forceUpdate();
            }
        },
        incrementMaxSlots(): void {
            if (!this.additionalService.maxSlots) {
                this.additionalService.maxSlots = 1
            } else {
                this.additionalService.maxSlots++
            }

            this.$forceUpdate();
        },
        decrementMaxSlots(): void {
            if (this.additionalService.maxSlots > 1) {
                this.additionalService.maxSlots--;
                this.$forceUpdate();
            }
            if (!this.additionalService.maxSlots) {
                this.additionalService.maxSlots = 1
                this.$forceUpdate();
            }
        },
        routeToPremiumServices(): void {

            if(this.serviceType === PremiumServiceEventTypes.Event){
                this.$router.push(`/concierge-events`);
                return
            }
            else if(this.serviceType === PremiumServiceEventTypes.Product){
                this.$router.push(`/concierge-products`);
                return
            }
            else if(this.serviceType === PremiumServiceEventTypes.Request){
                this.$router.push(`/concierge-requests`);
                return
            }
            else{
                this.$router.push(`/bookings-and-orders`);
                return
            }
        },
        routeToServiceRequest(id): void {
            this.$router.push("/bookings-and-orders/" + id);
        },
        async loadVendorsData() {
            if (!this.loadedVendorsData) {
                this.isVendorDataLoading = true
                await this.$store.dispatch("getEmailTemplates");
                await this.$store.dispatch("getVendors");
                this.isVendorDataLoading = false
                this.loadedVendorsData = true
            }
        },
        async loadCalenderEvents() {
            if (!this.loadedCalenderEvents) {
                await this.$store.dispatch('getCalenderEvents')
                this.loadedCalenderEvents = true
            }
        },
        async onChangeSendVendorEmailOption(e) {
            if (e === true) {
                this.additionalService.sendVendorEmailOptions = {
                    vendorId: null,
                    vendorName: null,
                    emailTemplateId: null
                }
                await this.loadVendorsData()
            } else {
                this.additionalService.sendVendorEmailOptions = null
            }
        },
        onVendorSelected(vendorId) {
            const vendor = this.currentVendors.find(x => x.id == vendorId)
            this.additionalService.sendVendorEmailOptions.vendorName = vendor.name
        },
        onUpdatedHours(data) {
            const editedPropsNames = Object.keys(data);

            if (!editedPropsNames || editedPropsNames?.length > 1) {
                throw Error('Unhandled error during updating the business-hours')
            }

            const editedDayPropName = editedPropsNames[0]
            const editedDayObj = data[editedDayPropName]
            this.additionalService.availableHours[editedDayPropName] = editedDayObj
            this.isPremiumServiceAvailableHoursValid = isPremiumServiceAvailableHoursValid(this.additionalService.availableHours)
        },
        async saveChanges(status?: string) {
            const form = this.$refs.form as any;
            const validated = form.validate();

            if (!validated || !this.isPremiumServiceAvailableHoursValid) return;

            //cast to string for MyHub
            this.additionalService.noticePeriod = this.additionalService.noticePeriod ? this.additionalService.noticePeriod.toString() : '';
            this.additionalService.oneOffCost = this.additionalService.oneOffCost ? this.additionalService.oneOffCost.toString() : '';
            this.additionalService.subscriptionCost = this.additionalService.subscriptionCost ? this.additionalService.subscriptionCost.toString() : '';

            // cast to number
            if (this.isRequest) {
                this.additionalService.durationHours = this.additionalService?.durationHours ? this.additionalService.durationHours : null;
            }

            if(this.isEvent && status && status === this.eventStatus.Published) {
                this.additionalService.isPublished = true;
            }
            
            this.additionalService.participantLimitNumber = Number(this.additionalService.participantLimitNumber);
            this.additionalService.maxSlots = Number(this.additionalService.maxSlots);

            if(this.additionalService.participantLimitNumber <=0){
                this.additionalService.participantLimitNumber = 0
            }

            if(this.additionalService.maxSlots <=0){
                this.additionalService.maxSlots = 0
            }

            if (this.serviceType === this.PremiumServiceEventTypes.Event && this.startDateSelected) {
                const start = new Date(`${this.startDateSelected} ${this.time.start}`);
                const end = new Date(`${this.startDateSelected} ${this.time.end}`);
                this.additionalService.start = firebase.firestore.Timestamp.fromDate(start);
                this.additionalService.end = firebase.firestore.Timestamp.fromDate(end);

                const office365Event = {startDateTime: null, endDateTime: null};

                 if (this.isOffice365Event) {

                    const startTime = moment(this.time.start, "hh:mm A")
                    const newEndTime = moment(this.time.start, "hh:mm A").add(this.office365DurationMins, 'minutes')

                    this.time.end = newEndTime.format("hh:mm A")

                    office365Event.startDateTime = moment(this.startDateSelected).set({
                        hour: startTime.hours(),
                        minute: startTime.minutes()
                    }).format('YYYY-MM-DDTHH:mm:ss');
                    
                    const endDateTime = moment(this.startDateSelected).set({
                        hour: newEndTime.hours(),
                        minute: newEndTime.minutes()
                    });

                    office365Event.endDateTime = endDateTime.format('YYYY-MM-DDTHH:mm:ss');
                    this.additionalService.end = firebase.firestore.Timestamp.fromDate(moment(endDateTime).toDate());
                }

                if (this.additionalService.eventId) {
                    if(this.isOffice365Event) {
                        this.updateEvent(office365Event);
                    } else {
                        this.updateEvent();
                    }
                }
            }

            if(this.additionalService.isWaitingList) {
                this.additionalService.waitingResidentsIds = this.additionalService.waitingResidentsIds || [];
                this.additionalService.waitingResidents = this.additionalService.waitingResidents || [];
            } else {
                delete this.additionalService.waitingResidentsIds;
                delete this.additionalService.waitingResidents;
                await this.deleteWaitingListFromService();
            }

            const category = this.serviceCategories.find(x => x.id === this.additionalService.categoryId);
            if(this.additionalService.categoryId && category) {
                this.additionalService.category = category?.name;
            }

            this.loadingChange = true;

            //TODO: pass only that fields that should be updated
            const additionalService = {...this.additionalService}
            delete additionalService.residentsRequests
            delete additionalService.restrictedResidents
            delete additionalService.membersList
            delete additionalService.membersIds

            if(this.isEvent) {
                this.updateServiceEvents();
            }

            await this.$store.dispatch("updateAdditionalService", additionalService);
            await this.$store.dispatch("getCurrentAdditionalServiceEvents", {
                additionalServiceId: this.additionalService?.id
            })
            await this.$store.dispatch("updateCategoryOrdersBookings", this.additionalService)
            await this.$store.dispatch("getAdditionalServices");
            this.$toast.open({
                message: this.$t(`EditPremiumService.SuccessSaved${this.serviceType}`),
                type: "success"
            })
            await this.loadMsCalendarEvents()
            this.loadingChange = false;
        },
        async deleteWaitingListFromService() {

            const updates: any = {
                waitingResidentsIds: firebase.firestore.FieldValue.delete(),
                waitingResidents: firebase.firestore.FieldValue.delete()
            }

            if(this.additionalService?.residentsRequests?.length){
                const residentsRequests = this.additionalService.residentsRequests.filter(x => x.type !== ResidentsRequestTypeEnum.WaitingList);
                updates.residentsRequests = residentsRequests;
            }

            await firebase
              .firestore()
              .collection("additionalServices")
              .doc(this.additionalService.id)
              .update(updates);
        },
        async updateEvent(office365Event) {
            const event: any = {
                name: this.additionalService.name,
                description: this.additionalService.description,
                start: this.additionalService.start,
                end: this.additionalService.end,
                duration: convertTimeDurationTo24hFormat(`${this.time.start}-${this.time.end}`),
                imageUrl: this.additionalService?.imageUrl,
                participantLimit: this.additionalService.participantLimit,
                participantLimitNumber: this.additionalService.participantLimitNumber,
                location: this.additionalService.location,
                wingsIds: this.additionalService.wingsIds ?? [],
                isPublished: this.additionalService.isPublished ?? false
            }

            if(this.additionalService.wing) {
                event.wing = this.additionalService.wing;
            }

            firebase
            .firestore()
            .collection("calender")
            .doc(this.additionalService?.eventId)
            .update(event)

            if (office365Event) {
                const params = {
                    id: this.additionalService.office365EventId,
                    subject: this.additionalService.name,
                    roomName: this.currentRoomLocation?.isDifferentName ? this.currentRoomLocation.differentName : this.currentRoomLocation.name,
                    startDateTime: office365Event.startDateTime,
                    endDateTime: office365Event.endDateTime,
                    office365ResourceEmail: this.currentRoomLocation?.office365Email || null,
                    facilityId: this.currentFacility
                }

                await this.$store.dispatch('updateMsEvent', params).then(async response => {
                    if(response.data?.status !== 200){
                        this.$toast.error(this.$t("NewCalendarItem.ErrorCreatingMsEvent") as string)
                    }
                });
            }
        },
        async deleteService() {
            await this.$store.dispatch("getAdditionalServiceRequestsByServiceId", this.additionalService.id);
            const requests = await this.$store.state.additionalServicesModule.serviceRequestByServiceId;
            let isRemovePremiumService = true;

            (this.$refs.confirmationMessageModal as any)
                .open(
                    null,
                    (this.$i18n.messages[this.$i18n.locale]['EditPremiumService.DeleteMessage'] as string).replace('[serviceType]', this.serviceType.toLowerCase()),
                    false,
                    "",
                    null,
                    `${(this.$i18n.messages[this.$i18n.locale]['EditPremiumService.SuccessDeleteMessage'] as string).replace('[serviceType]', this.serviceType.toLowerCase())} "${this.additionalService.name}"`,
                    (this.$i18n.messages[this.$i18n.locale]['EditPremiumService.ServiceHasOpenRequestMessage'] as string)
                        .replace('[additionalServiceName]', this.serviceType.toLowerCase())
                        .replace('[eventNames]', this.serviceType !== 'Product' ? 'bookings' : 'orders')
                    ,
                    this.$i18n.messages[this.$i18n.locale]['EditPremiumService.Loading'],
                    this.additionalService.id
                )
                .then(async response => {
                    if (response && response.agree) {

                        requests.forEach((item) => {
                            if (
                                item.status === ServiceStatus.AwaitingApproval ||
                                item.status === ServiceStatus.Approved
                            ) {
                                isRemovePremiumService = false;
                            }
                        })

                        if (isRemovePremiumService) {
                            await this.$store.dispatch("deleteAdditionalService", { additionalServiceId: this.additionalService.id, office365EventId: this.additionalService?.office365EventId })
                                .then(async () => {
                                    await this.changeOrderIndexesForServices();
                                    this.routeToPremiumServices();
                                })
                        } else {
                            (this.$refs.confirmationMessageModal as any).error();
                        }
                    }
                });
        },
        async changeOrderIndexesForServices() {
            const itemsToUpdate = this.additionalServices
                .filter(x => x.id !== this.$route.params.id)
                .map((item, index) => {
                    return {docId: item.id, updates: {orderIndex: index + 1}};
                })

            await batchUpdate('additionalServices', itemsToUpdate).then(() => {
                this.loading = false;
            })
        },
        remove(restrictedResidents, item): void {
            const index = restrictedResidents.indexOf(item.id);
            if (index >= 0) restrictedResidents.splice(index, 1);
        },
        setCostServices() {
            if (this.additionalService?.oneOffCost && this.additionalService?.oneOffCost !== 'POA' && this.additionalService?.oneOffCost !== 'Free') {
                this.oneOffCost = this.additionalService?.oneOffCost;
                this.$forceUpdate()
            }
        },
        async saveProfilePic(e) {
            const imgGuid = uuidv4();
            const file: File | Blob | any = await optimizePhotos(e.target.files[0], '');
            const fileSizeInMegabytes = fileSizeToMB(file?.size);

            if (!validFileSize10MB(fileSizeInMegabytes)) {
                this.$refs.inputUpload.value = null;
                console.error('File size is too big');
                return;
            }

            const storageRef: any = firebase
                .storage()
                .ref()
                .child(this.currentFacility)
                .child("additionalServices")
                .child("images")
                .child(imgGuid)
                .put(file);

            const path = (await storageRef)?.metadata?.fullPath
            const thumbnailImageRef = firebase.storage().ref().child(`${path}_200x200`);

            storageRef.on(
                `state_changed`,
                snapshot => {
                    this.profilePicUploadStatus =
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                },
                error => {
                    console.error(error.message);
                },
                () => {
                    storageRef.snapshot.ref.getDownloadURL().then(async url => {
                        this.additionalService.imageUrl = url;
                        this.additionalService.thumbnailUrl = await waitResizedImage(10, thumbnailImageRef);
                        console.log('image set successfully');
                        this.saveChanges();
                    });
                }
            );
        },
        loadRecurringEvents(eventId): void {
            this.$store.dispatch("clearCurrentCalenderRecurringEvents");
            this.$store.dispatch("getCalenderRecurringEvents", eventId);
        },
        unsubscribe(item) {

            (this.$refs.confirmationModal as any)
                .open(null, this.$i18n.messages[this.$i18n.locale]['EditPremiumService.UnsubscribeServiceMessage'], false)
                .then(async response => {
                  if (response && response.agree) {
                      this.loading = true;

                      //to immediately see changes on the UI
                      this.additionalService.membersList = this.additionalService?.membersList.filter(
                        x => x.id !== item.id
                      );

                      //really unsubscribe
                      firebase.app().functions(getRegionName())
                        .httpsCallable("unsubscribeAdditionalService")({
                            memberId: item.id,
                            additionalServiceId: this.$route.params.id,
                            staffUserName: this.$store.state.authModule.user.name
                        })
                        .then(async () => {
                            await this.$store.dispatch(
                              "getAdditionalService",
                              this.$route.params.id
                            );
                            await this.rejectServiceRequest(item);
                            await this.$store.dispatch("getAdditionalServiceRequestsByServiceId", this.additionalService.id);
                            this.$toast.open({
                                type: "success",
                                message: this.$t("EditPremiumService.SuccessCanceledService")
                            })
                        }).finally(() => {
                          this.loading = false;
                      })
                  }
            })
        },
        async rejectServiceRequest(item) {
            await firebase
              .firestore()
              .collection("serviceRequests")
              .doc(item.serviceRequestId)
              .get()
              .then(async (querySnapshot) => {
                  const request: any = serializer.documentSnapshotToDocument(querySnapshot);
                  const id = request.id;
                  const rejectReason = "Other";
                  const rejectComment = "";

                  const payload = {
                      id,
                      rejectReason,
                      rejectComment
                  };

                  await this.$store.dispatch("rejectAdditionalServiceRequest", payload);

                  let title, body = ``

                  const eventTypes = Object.values(PremiumServiceEventTypeEnum)
                  const requestTypes = Object.values(PremiumServiceRequestTypeEnum)
                  const productTypes = Object.values(PremiumServiceProductTypeEnum)

                  if(eventTypes.includes(request.serviceItemType) || requestTypes.includes(request.serviceItemType)){
                      title = `The ${request.serviceName} booking for ${request.residentName} in ${this.facility.name} was rejected`
                      body = `The <b>${request.serviceName}</b> booking for <b>${request.residentName}</b> in <b>${this.facility.name}</b> was rejected. A refund might be needed. 
                        Click <a href="https://${this.$store.state.facilityModule.selectedFacility.baseUrl}/bookings-and-orders/${request.id}">here</a> to view the booking.`
                  }

                  else if (productTypes.includes(request.serviceItemType)){
                      title = `The ${request.serviceName} order for ${request.residentName} in ${this.facility.name} was rejected`
                      body = `The <b>${request.serviceName}</b> order for <b>${request.residentName}</b> in <b>${this.facility.name}</b> was rejected. A refund might be needed. 
                        Click <a href="https://${this.$store.state.facilityModule.selectedFacility.baseUrl}/bookings-and-orders/${request.id}">here</a> to view the order.`
                  }

                  await firebase
                    .firestore()
                    .collection('email')
                    .add({
                        to: "support@getreshub.com",
                        facilityId: this.facility.id,
                        message: {
                            subject: title,
                            html: body
                        }
                    })
              })
        },
        onChangeParticipantLimit() {
            if (this.additionalService.participantLimit !== this.PremiumServiceParticipantsLimitTypes.SetLimit) {
                this.additionalService.isWaitingList = false;
            }

            if (this.additionalService.participantLimit === this.PremiumServiceParticipantsLimitTypes.SetLimit) {
                this.additionalService.participantLimitNumber = 1
            } else {
                this.additionalService.participantLimitNumber = null
            }

            if (this.additionalService.participantLimit === this.PremiumServiceParticipantsLimitTypes.LimitPerTimeSlot) {
                this.additionalService.maxSlots = 1
            } else {
                this.additionalService.maxSlots = null
            }

            this.$forceUpdate();
        },
        openGalleryPhotos(index) {
            this.indexAdditionalPhoto = index ?? null;
            (this.$refs.GalleryPhotosUploadDlg as any).open();
        },
        uploadGalleryPhoto(image: GalleryImage) {
            if (this.indexAdditionalPhoto === null) {
                this.additionalService.imageUrl = image.image;
                this.additionalService.thumbnailUrl = image?.thumbnailUrl ?? image.image;
            } else {
                this.additionalService.additionalPhotos[this.indexAdditionalPhoto].photoUrl = image.image;
                this.additionalService.additionalPhotos[this.indexAdditionalPhoto].thumbnailUrl = image?.thumbnailUrl ?? image.image;
            }
            this.$forceUpdate();
        },
        decrementDurationHours() {
            if (this.additionalService.durationHours) {
              let duration = parseFloat(this.additionalService.durationHours);
              if (duration > 1) {
                duration--;
                this.additionalService.durationHours = duration.toFixed(1);
              } else if (duration === 1) {
                this.additionalService.durationHours = null;
              }
              this.$forceUpdate();
            }
          },
          incrementDurationHours() {
            if (!this.additionalService.durationHours) {
              this.additionalService.durationHours = '1';
            } else {
              let duration = parseFloat(this.additionalService.durationHours);
              duration++;
              this.additionalService.durationHours = duration.toFixed(1);
            }
            this.$forceUpdate();
        },
        onTimeRangeChange(timeRange) {
            this.time.start = timeRange.startTime;
            this.time.end = timeRange.endTime;
            this.$forceUpdate();
        },
        openEvent() {
            this.$router.push("/calendar/" + this.additionalService.eventId);
        },
        uploadAdditionalPhoto(index) {
            const refName = `imageUpload${index}`;
            const refElement = this.$refs[refName];

            setTimeout(() => {
                refElement[0].click();
            }, 100)
        },
        async saveAdditionalPhoto(e, index) {
            const ref = uuidv4();
            const file: File | Blob | any = await optimizePhotos(e.target.files[0], '');
            const fileSizeInMegabytes = fileSizeToMB(file?.size);

            if (!validFileSize10MB(fileSizeInMegabytes)) {
                const refName = `imageUpload${index}`;
                const refElement = this.$refs[refName];

                setTimeout(() => {
                    refElement[0].value = null;
                }, 100);
                return;
            }

            const storageRef = firebase
                .storage()
                .ref()
                .child(this.currentFacility)
                .child("additionalServices")
                .child("images")
                .child(ref)
                .put(file);

            storageRef.on(
                `state_changed`,
                () => {
                    console.log("loading...")
                },
                error => {
                    console.error(error.message);
                },
                () => {
                    storageRef.snapshot.ref.getDownloadURL().then(url => {
                        this.additionalService.additionalPhotos[index].photoUrl = url;
                    });
                }
            );
        },
        deleteAdditionalGalleryPhoto(index) {
            this.additionalService.additionalPhotos.splice(index, 1);
        },
        addMorePhotos() {
            this.additionalService?.additionalPhotos.push({
                photoUrl: require("@/assets/no-image.jpg"),
            });
            this.$forceUpdate();
        },
        changeAppointment() {
            if (this.additionalService.byAppointment) {
                this.additionalService.durationHours = 0;
            } else {
                this.additionalService.durationHours = 1;
            }
        },
        handleDurationHours() {
            if (this.additionalService.durationHours[0] === "0") {
                this.additionalService.durationHours = String(Number(this.additionalService.durationHours));
            }
        },
        handleMaxSlots() {
            if (this.additionalService.maxSlots[0] === "0") {
                this.additionalService.maxSlots = String(Number(this.additionalService.maxSlots));
                this.$forceUpdate()
            }
        },
        handleParticipantLimit() {
            if (this.additionalService.participantLimitNumber[0] === "0") {
                this.additionalService.participantLimitNumber = String(Number(this.additionalService.participantLimitNumber));
                this.$forceUpdate()
            }
        },
        handlePrice() {
            if (this.oneOffCost[0] === "0") {
                this.oneOffCost = String(Number(this.oneOffCost));
                this.$forceUpdate()
            }
        },
        async removeFromWaitingList(memberId) {
            (this.$refs.confirmationModal as any)
              .open(null, this.$i18n.messages[this.$i18n.locale]['EditPremiumService.CancelServiceBooking'], false)
              .then(async response => {
                  if (response && response.agree) {

                    const waitingResidents = this.additionalService?.waitingResidents?.filter(x => x.id !== memberId) || []
                    const residentsRequests = (this.additionalService?.residentsRequests || [])
                            .filter(request => !(request.residentId === memberId && request.type === ResidentsRequestTypeEnum.WaitingList))
                            
                      await firebase
                        .firestore()
                        .collection("additionalServices")
                        .doc(this.additionalService.id)
                        .update({
                            waitingResidentsIds: firebase.firestore.FieldValue.arrayRemove(memberId),
                            waitingResidents: waitingResidents,
                            residentsRequests: residentsRequests
                        }).then(async () => {
                            await this.$store.dispatch("getAdditionalService", this.$route.params.id)

                            this.$toast.open({
                                type: "success",
                                message: this.$t("EditPremiumService.SuccessRemoveFromWaitingList")
                            });
                        })
                  }
              })
        },
        updateServiceEvents() {
            this.additionalService.events.forEach((event) => {
                event.name = this.additionalService.name;
                event.description = this.additionalService.description;
                event.start = this.additionalService.start;
                event.end = this.additionalService.end;
                event.duration = convertTimeDurationTo24hFormat(`${this.time.start}-${this.time.end}`);
                event.imageUrl = this.additionalService?.imageUrl;
                event.participantLimit = this.additionalService.participantLimit;
                event.participantLimitNumber = this.additionalService.participantLimitNumber;
                event.location = this.additionalService.location;
                event.wingsIds = this.additionalService.wingsIds ?? [];
                event.isPublished = this.additionalService.isPublished ?? false;

                if(this.additionalService.wing) {
                    event.wing = this.additionalService.wing;
                }
            });
        }
    },
    watch: {
        oneOffCost(newValue) {
            this.additionalService.oneOffCost = newValue;
            this.$forceUpdate();
        },
        selectedWingsIds(newValue) {
            this.additionalService.wingsIds = newValue;
        },
        "additionalService.participantLimit"(newValue, oldValue) {
            if(newValue === PremiumServiceParticipantsLimit.SetLimit && !this.additionalService?.hasOwnProperty('isWaitingList')) {
                this.additionalService.isWaitingList = false;
            }

            if(newValue === PremiumServiceParticipantsLimit.SetLimit && oldValue && oldValue !== PremiumServiceParticipantsLimit.SetLimit) {
                this.additionalService.updatedLimitDateTime = firebase.firestore.Timestamp.fromDate(new Date());
            }
        },
        "additionalService.participantLimitNumber"(newValue, oldValue) {
            if(newValue && oldValue && newValue !== oldValue) {
                this.additionalService.updatedLimitDateTime = firebase.firestore.Timestamp.fromDate(new Date());
            }
        },
    },
}
